import React, { createContext, useState, useEffect } from "react";
import useAxios from "../../hooks/useAxios";
import PropTypes from "prop-types";
import FormatFiltersQuery from "./helpers/FormatFiltersQuery";
import handleFilterSelect from "./actions/handleFilterSelect";
import clearAllFilters from "./actions/clearAllFilters";
import { handleButtonPageSelect, handleDecrementPage, handleIncrementPage } from "../Pagination/actions/paginationActions";

const Context = createContext();

// Handles global states and state updates for the entire app

export const AppProvider = ({children, indexPage, language}) => {
	const [selectedFilters, setSelectedFilters] = useState({});
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [itemsUrl, setItemsUrl] = useState(
		`${indexPage}?page=${currentPageNumber}&lang=${language}${FormatFiltersQuery(
			selectedFilters
		)}`
	);

	const filtersEndPoint = {
		news: "post",
		stories: "success_story",
	}
    
	// fetch all the filters from the API
	const { response: filters } = useAxios(`filters?type=${filtersEndPoint[indexPage]}&lang=${language}`);
	const { response: items, totalPages, message } = useAxios(itemsUrl);

	useEffect(() => {
		// request doesnt get called twice on initial because the string should match the
		setItemsUrl(
			`${indexPage}?page=${currentPageNumber}&lang=${language}${FormatFiltersQuery(
				selectedFilters
			)}`
		);
	}, [selectedFilters, currentPageNumber]);

	

	const data = {
		// data or state to be passed on to child components
		filters,
		items,
		totalPages,
		selectedFilters,
		currentPageNumber,
		indexPage,
		language,
		message,
	};

	const actions = {
	// handlers and mutation functions that would be passed down to components
		handleFilterSelect,
		setSelectedFilters,
		setCurrentPageNumber,
		clearAllFilters,
		handleIncrementPage,
		handleDecrementPage,
		handleButtonPageSelect,
	};

	return (
		<Context.Provider value={{ actions, data }}>{children}</Context.Provider>
	);
};

AppProvider.propTypes = {
	children: PropTypes.any,
	indexPage: PropTypes.string,
	language: PropTypes.string,
}

export default Context;